import { initialState } from ".";
import {
	GET_SHOP_FAIL,
	GET_SHOP_START,
	GET_SHOP_SUCCESS,
	UPDATE_SHOP_START,
	UPDATE_SHOP_FAIL,
	UPDATE_SHOP_SUCCESS,
	CREATE_SHOP_START,
	CREATE_SHOP_FAIL,
	CREATE_SHOP_SUCCESS,
	GET_SHOP_PRODUCTS_START,
	GET_SHOP_PRODUCTS_SUCCESS,
	GET_SHOP_PRODUCTS_FAIL,
	GET_SHOP_ADDONS_START,
	GET_SHOP_ADDONS_SUCCESS,
	GET_SHOP_ADDONS_FAIL,
	UPDATE_SHOP_PRODUCT_START,
	UPDATE_SHOP_PRODUCT_SUCCESS,
	UPDATE_SHOP_PRODUCT_FAIL,
	DELETE_SHOP_PRODUCT_START,
	DELETE_SHOP_PRODUCT_SUCCESS,
	DELETE_SHOP_PRODUCT_FAIL,
	CREATE_SHOP_PRODUCT_SUCCESS,
	CREATE_SHOP_PRODUCT_START,
	CREATE_SHOP_PRODUCT_FAIL,
	CREATE_VARIANT_START,
	CREATE_VARIANT_SUCCESS,
	CREATE_VARIANT_FAIL,
	GET_SHOP_ORDERS_START,
	GET_SHOP_ORDERS_SUCCESS,
	GET_SHOP_ORDERS_FAIL,
	UPDATE_SHOP_ORDER_START,
	UPDATE_SHOP_ORDER_SUCCESS,
	UPDATE_SHOP_ORDER_FAIL,
	// UPDATE_SHOP_ADDON_START,
	UPDATE_SHOP_ADDON_SUCCESS,
	// UPDATE_SHOP_ADDON_FAIL,
	// DELETE_SHOP_ADDON_START,
	DELETE_SHOP_ADDON_SUCCESS,
	// DELETE_SHOP_ADDON_FAIL,
	CREATE_SHOP_ADDON_START,
	CREATE_SHOP_ADDON_SUCCESS,
	CREATE_SHOP_ADDON_FAIL,
} from "../actions/shop";

import { LOGOUT } from "../actions/session";
import { mergeObjectArrays } from "../helpers";

export default function (shop = initialState.shop, action) {
	switch (action.type) {

		case UPDATE_SHOP_START:
		case GET_SHOP_PRODUCTS_START:
		case GET_SHOP_ORDERS_START:
		case GET_SHOP_ADDONS_START:
		case GET_SHOP_START:
			return { ...shop, loading: true }

		case UPDATE_SHOP_FAIL:
		case GET_SHOP_PRODUCTS_FAIL:
		case GET_SHOP_ORDERS_FAIL:
		case GET_SHOP_ADDONS_FAIL:
		case GET_SHOP_FAIL:
			return { ...shop, loading: false }

		case UPDATE_SHOP_SUCCESS:
		case GET_SHOP_SUCCESS:
			return {
				orders: shop.orders,
				products: shop.products,
				addOns: shop.addOns,
				...action.shop,
				loading: false
			}

		case CREATE_SHOP_SUCCESS:
			return {
				orders: shop.orders,
				products: shop.products,
				...action.shop,
				loading: false,
				creating: false,
				shopCreationError: null
			}

		case CREATE_SHOP_START:
			return {
				orders: [],
				products: [],
				loading: true,
				creating: true,
				shopCreationError: null
			}

		case CREATE_SHOP_FAIL:
			return {
				...shop,
				loading: false,
				creating: false,
				shopCreationError: action.error || "Something went wrong."
			}

		case GET_SHOP_PRODUCTS_SUCCESS:
			return {
				...shop,
				products: action.products,
				loading: false
			}

		case GET_SHOP_ORDERS_SUCCESS:
			return {
				...shop,
				orders: mergeObjectArrays(shop.orders, action.orders, (a, b) => a.id === b.id),
				loading: false
			}

		case GET_SHOP_ADDONS_SUCCESS:
			return {
				...shop,
				addOns: action.addOns,
				loading: false
			}

		case UPDATE_SHOP_ORDER_START:
			return {
				...shop,
				orders: shop.orders
					.map(order => order.id === action.orderId ?
						{ ...order, loading: true } : order
					)
			}
		case UPDATE_SHOP_ORDER_FAIL:
			return {
				...shop,
				orders: shop.orders
					.map(order => order.id === action.orderId ?
						{ ...order, loading: false } : order
					)
			}
		case UPDATE_SHOP_ORDER_SUCCESS:
			return {
				...shop,
				orders: shop.orders
					.map(order => order.id === action.order.id ?
						{ ...action.order, loading: false } : order
					)
			}

		// Variant creation requires the parent product to be loading,
		// and shop to be creating.
		case CREATE_VARIANT_START:
			return {
				...shop,
				creating: true,
				products: shop.products
					.map(p => p.id === action.productId ? { ...p, loading: true } : p)
			}

		// Success will require adding the new variant to the products array,
		// and updating the exsisting one.
		case CREATE_VARIANT_SUCCESS:
			return {
				...shop,
				creating: false,
				products: shop.products
					.map(p => p.id === action.productId ? {
						...p,
						loading: false
					} : p)
					.concat([action.variant])
			}

		case CREATE_VARIANT_FAIL:
			return {
				...shop,
				creating: false,
				products: shop.products
					.map(p => p.id === action.productId ? { ...p, loading: false } : p)
			}

		// Shop products.
		case CREATE_SHOP_PRODUCT_START:
			return {
				...shop,
				creating: true
			}
		case CREATE_SHOP_PRODUCT_FAIL:
			return {
				...shop,
				creating: false
			}
		case CREATE_SHOP_PRODUCT_SUCCESS:
			return {
				...shop,
				creating: false,
				products: [...shop.products, action.product]
			}

		case DELETE_SHOP_PRODUCT_START:
		case UPDATE_SHOP_PRODUCT_START:
			return {
				...shop,
				products: shop.products
					.map(product => product.id === action.productId ?
						{ ...product, loading: true } : product
					)
			}
		case DELETE_SHOP_PRODUCT_FAIL:
		case UPDATE_SHOP_PRODUCT_FAIL:
			return {
				...shop,
				products: shop.products
					.map(product => product.id === action.productId ?
						{ ...product, loading: false } : product
					)
			}

		// When a product is deleted, also make sure to check for any
		// products that used it as a variant.
		case DELETE_SHOP_PRODUCT_SUCCESS:
			return {
				...shop,
				products: shop.products
					.filter(product => product.id !== action.productId)
					.map(product => (product.variants || []).includes(action.productId) ? {
						...product,
						variants: product.variants.filter(pid => pid !== action.productId)
					} : product)
			}
		case UPDATE_SHOP_PRODUCT_SUCCESS:
			return {
				...shop,
				products: shop.products
					.map(product => product.id === action.product.id ?
						{ ...action.product, loading: false } : product
					)
			}

		// Add-ons.
		// Creating.
		case CREATE_SHOP_ADDON_START:
			return {
				...shop,
				creating: true
			}
		case CREATE_SHOP_ADDON_SUCCESS:
			return {
				...shop,
				creating: false,
				addOns: mergeObjectArrays(
					shop.addOns,
					[action.addOn],
					(a, b) => a.id === b.id
				),
			}
		case CREATE_SHOP_ADDON_FAIL:
			return {
				...shop,
				creating: false
			}

		// case UPDATE_SHOP_ADDON_START:
		// case UPDATE_SHOP_ADDON_FAIL:
		case UPDATE_SHOP_ADDON_SUCCESS:
			return {
				...shop,
				addOns: mergeObjectArrays(
					shop.addOns,
					[action.addOn],
					(a, b) => a.id === b.id
				),
			}

		// case DELETE_SHOP_ADDON_START:
		// case DELETE_SHOP_ADDON_FAIL:
		case DELETE_SHOP_ADDON_SUCCESS:
			return {
				...shop,
				addOns: shop.addOns
					.filter(a => a.id !== action.addOnId)
			}

		case LOGOUT:
			return {
				loading: true,
				creating: false,
				products: [],
				addOns: [],
				orders: []
			}

		default:
			return shop;
	}
}